module.exports = __webpack_public_path__ + "fonts/DroidKufi-Regular.a9b030e2.ttf";